import { BodyPrimary, BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { getCatalogDetailCurators } from '@/redux/modules/catalog/detail/catalogDetail.selectors';
import { getCuratorBaseUrl } from '@/redux/modules/config';
import { getCuratorImageUrl } from '@/utils/urls';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

type Curator = {
    expertise: string;
    id: number;
    imageFileName: string;
    name: string;
};

type Props = {
    catalogId: number;
    className?: string;
};

const IMAGE_SIZE = 64;

export const CuratorInfo = ({ catalogId }: Props) => {
    const { formatMessage } = useIntl();
    const catalogCurators = useAppSelector((state) => getCatalogDetailCurators(state, catalogId));
    const curatorBaseUrl = useAppSelector(getCuratorBaseUrl);

    const mapCurators = useCallback(
        (curator: Curator) => {
            return (
                <div
                    className="mt-md flex gap-xs"
                    key={curator.id}
                >
                    <div className="flex h-2xl min-h-2xl w-2xl min-w-2xl items-center justify-center overflow-hidden rounded-full">
                        <img
                            alt={curator.name}
                            className="max-h-full max-w-full object-contain"
                            height={64}
                            loading="lazy"
                            src={getCuratorImageUrl(curatorBaseUrl, curator.id, curator.imageFileName, IMAGE_SIZE)}
                            width={64}
                        />
                    </div>
                    <div className="flex w-full flex-col items-start justify-center gap-2xs">
                        <span className="hui-text-h5">{curator.name}</span>
                        <BodySecondary color="secondary">{curator.expertise}</BodySecondary>
                    </div>
                </div>
            );
        },
        [curatorBaseUrl]
    );

    if (!catalogCurators.length) {
        return null;
    }

    return (
        <div>
            <BodyPrimary>
                {formatMessage({ id: 'bidding_console.console.currentLiveItem.curator.curatedBy' })}
            </BodyPrimary>
            {catalogCurators.map(mapCurators)}
        </div>
    );
};
